import A0 from "./00000.jpg";
import A1 from "./00001.jpg";
import A2 from "./00002.jpg";
import A3 from "./00003.jpg";
import A4 from "./00004.jpg";
import A5 from "./00005.jpg";
import A6 from "./00006.jpg";
import A7 from "./00007.jpg";
import A8 from "./00008.jpg";
import A9 from "./00009.jpg";

import A10 from "./00010.jpg";
import A11 from "./00011.jpg";
import A12 from "./00012.jpg";
import A13 from "./00013.jpg";
import A14 from "./00014.jpg";
import A15 from "./00015.jpg";
import A16 from "./00016.jpg";
import A17 from "./00017.jpg";
import A18 from "./00018.jpg";
import A19 from "./00019.jpg";

import A20 from "./00020.jpg";
import A21 from "./00021.jpg";
import A22 from "./00022.jpg";
import A23 from "./00023.jpg";
import A24 from "./00024.jpg";
import A25 from "./00025.jpg";
import A26 from "./00026.jpg";
import A27 from "./00027.jpg";
import A28 from "./00028.jpg";
import A29 from "./00029.jpg";

import A30 from "./00030.jpg";
import A31 from "./00031.jpg";
import A32 from "./00032.jpg";
import A33 from "./00033.jpg";
import A34 from "./00034.jpg";
import A35 from "./00035.jpg";
import A36 from "./00036.jpg";
import A37 from "./00037.jpg";
import A38 from "./00038.jpg";
import A39 from "./00039.jpg";

import A40 from "./00040.jpg";
import A41 from "./00041.jpg";
import A42 from "./00042.jpg";
import A43 from "./00043.jpg";
import A44 from "./00044.jpg";
import A45 from "./00045.jpg";
import A46 from "./00046.jpg";
import A47 from "./00047.jpg";
import A48 from "./00048.jpg";
import A49 from "./00049.jpg";

import A50 from "./00050.jpg";
import A51 from "./00051.jpg";
import A52 from "./00052.jpg";
import A53 from "./00053.jpg";
import A54 from "./00054.jpg";
import A55 from "./00055.jpg";
import A56 from "./00056.jpg";
import A57 from "./00057.jpg";
import A58 from "./00058.jpg";
import A59 from "./00059.jpg";

import A60 from "./00060.jpg";
import A61 from "./00061.jpg";
import A62 from "./00062.jpg";
import A63 from "./00063.jpg";
import A64 from "./00064.jpg";
import A65 from "./00065.jpg";
import A66 from "./00066.jpg";
import A67 from "./00067.jpg";
import A68 from "./00068.jpg";
import A69 from "./00069.jpg";

import A70 from "./00070.jpg";
import A71 from "./00071.jpg";
import A72 from "./00072.jpg";
import A73 from "./00073.jpg";
import A74 from "./00074.jpg";
import A75 from "./00075.jpg";
import A76 from "./00076.jpg";
import A77 from "./00077.jpg";
import A78 from "./00078.jpg";
import A79 from "./00079.jpg";

import A80 from "./00080.jpg";
import A81 from "./00081.jpg";
import A82 from "./00082.jpg";
import A83 from "./00083.jpg";
import A84 from "./00084.jpg";
import A85 from "./00085.jpg";
import A86 from "./00086.jpg";
import A87 from "./00087.jpg";
import A88 from "./00088.jpg";
import A89 from "./00089.jpg";

import A90 from "./00090.jpg";
import A91 from "./00091.jpg";
import A92 from "./00092.jpg";
import A93 from "./00093.jpg";
import A94 from "./00094.jpg";
import A95 from "./00095.jpg";
import A96 from "./00096.jpg";
import A97 from "./00097.jpg";
import A98 from "./00098.jpg";
import A99 from "./00099.jpg";

import A100 from "./00100.jpg";
import A101 from "./00101.jpg";
import A102 from "./00102.jpg";
import A103 from "./00103.jpg";
import A104 from "./00104.jpg";
import A105 from "./00105.jpg";
import A106 from "./00106.jpg";
import A107 from "./00107.jpg";
import A108 from "./00108.jpg";
import A109 from "./00109.jpg";

import A110 from "./00110.jpg";
import A111 from "./00111.jpg";
import A112 from "./00112.jpg";
import A113 from "./00113.jpg";
import A114 from "./00114.jpg";
import A115 from "./00115.jpg";
import A116 from "./00116.jpg";
import A117 from "./00117.jpg";
import A118 from "./00118.jpg";
import A119 from "./00119.jpg";

import A120 from "./00120.jpg";
import A121 from "./00121.jpg";
import A122 from "./00122.jpg";
import A123 from "./00123.jpg";
import A124 from "./00124.jpg";
import A125 from "./00125.jpg";
import A126 from "./00126.jpg";
import A127 from "./00127.jpg";
import A128 from "./00128.jpg";
import A129 from "./00129.jpg";

import A130 from "./00130.jpg";
import A131 from "./00131.jpg";
import A132 from "./00132.jpg";
import A133 from "./00133.jpg";
import A134 from "./00134.jpg";
import A135 from "./00135.jpg";
import A136 from "./00136.jpg";
import A137 from "./00137.jpg";
import A138 from "./00138.jpg";
import A139 from "./00139.jpg";

import A140 from "./00140.jpg";
import A141 from "./00141.jpg";
import A142 from "./00142.jpg";
import A143 from "./00143.jpg";
import A144 from "./00144.jpg";
import A145 from "./00145.jpg";
import A146 from "./00146.jpg";
import A147 from "./00147.jpg";
import A148 from "./00148.jpg";
import A149 from "./00149.jpg";

import A150 from "./00150.jpg";
import A151 from "./00151.jpg";
import A152 from "./00152.jpg";
import A153 from "./00153.jpg";
import A154 from "./00154.jpg";
import A155 from "./00155.jpg";
import A156 from "./00156.jpg";
import A157 from "./00157.jpg";
import A158 from "./00158.jpg";
import A159 from "./00159.jpg";

import A160 from "./00160.jpg";
import A161 from "./00161.jpg";
import A162 from "./00162.jpg";
import A163 from "./00163.jpg";
import A164 from "./00164.jpg";
import A165 from "./00165.jpg";
import A166 from "./00166.jpg";
import A167 from "./00167.jpg";
import A168 from "./00168.jpg";
import A169 from "./00169.jpg";

import A170 from "./00170.jpg";
import A171 from "./00171.jpg";
import A172 from "./00172.jpg";
import A173 from "./00173.jpg";
import A174 from "./00174.jpg";
import A175 from "./00175.jpg";
import A176 from "./00176.jpg";

export const beHealthierImages = Array.of(
  A0,
  A1,
  A2,
  A3,
  A4,
  A5,
  A6,
  A7,
  A8,
  A9,

  A10,
  A11,
  A12,
  A13,
  A14,
  A15,
  A16,
  A17,
  A18,
  A19,

  A20,
  A21,
  A22,
  A23,
  A24,
  A25,
  A26,
  A27,
  A28,
  A29,

  A30,
  A31,
  A32,
  A33,
  A34,
  A35,
  A36,
  A37,
  A38,
  A39,

  A40,
  A41,
  A42,
  A43,
  A44,
  A45,
  A46,
  A47,
  A48,
  A49,

  A50,
  A51,
  A52,
  A53,
  A54,
  A55,
  A56,
  A57,
  A58,
  A59,

  A60,
  A61,
  A62,
  A63,
  A64,
  A65,
  A66,
  A67,
  A68,
  A69,

  A70,
  A71,
  A72,
  A73,
  A74,
  A75,
  A76,
  A77,
  A78,
  A79,

  A80,
  A81,
  A82,
  A83,
  A84,
  A85,
  A86,
  A87,
  A88,
  A89,

  A90,
  A91,
  A92,
  A93,
  A94,
  A95,
  A96,
  A97,
  A98,
  A99,

  A100,
  A101,
  A102,
  A103,
  A104,
  A105,
  A106,
  A107,
  A108,
  A109,

  A110,
  A111,
  A112,
  A113,
  A114,
  A115,
  A116,
  A117,
  A118,
  A119,

  A120,
  A121,
  A122,
  A123,
  A124,
  A125,
  A126,
  A127,
  A128,
  A129,

  A130,
  A131,
  A132,
  A133,
  A134,
  A135,
  A136,
  A137,
  A138,
  A139,

  A140,
  A141,
  A142,
  A143,
  A144,
  A145,
  A146,
  A147,
  A148,
  A149,

  A150,
  A151,
  A152,
  A153,
  A154,
  A155,
  A156,
  A157,
  A158,
  A159,

  A160,
  A161,
  A162,
  A163,
  A164,
  A165,
  A166,
  A167,
  A168,
  A169,

  A170,
  A171,
  A172,
  A173,
  A174,
  A175,
  A176
);
